/* eslint-disable */
(function () {
  if (window.performance && window.performance.mark) {
    window.performance.mark('scriptStartTime');
  }

  var isLocal = /local-ap1.hubspot.com/.test(document.location.hostname);
  if (!isLocal) {
    enviro.set('SENTRY_DEPLOYED', true);
  }

  if (window.Raven) {
    try {
      var isIframe = window.self !== window.top;
      window.Raven.setExtraContext({ isIframe: isIframe });
    } catch (e) {
      window.Raven.setExtraContext({ isIframe: 'unknown' });
    }
  }

  window.hubspot.meetingsHubletOverride = 'ap1';
})();


